import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';

export default function ProblemAnimation() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-50px' });

  // Two bids colliding - chaos!
  return (
    <div ref={ref} className="relative w-full h-64 md:h-80">
      <svg viewBox="0 0 400 200" className="w-full h-full">
        {/* Auction item in center */}
        <motion.g
          initial={{ scale: 0 }}
          animate={isInView ? { scale: 1 } : { scale: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          {/* Isometric box - auction item */}
          <polygon
            points="200,60 260,90 200,120 140,90"
            fill="#3b82f6"
            stroke="#1d4ed8"
            strokeWidth="2"
          />
          <polygon
            points="200,120 260,90 260,130 200,160"
            fill="#2563eb"
            stroke="#1d4ed8"
            strokeWidth="2"
          />
          <polygon
            points="200,120 140,90 140,130 200,160"
            fill="#1d4ed8"
            stroke="#1e40af"
            strokeWidth="2"
          />
          {/* Star on top */}
          <motion.text
            x="200"
            y="95"
            textAnchor="middle"
            fontSize="24"
            initial={{ opacity: 0 }}
            animate={isInView ? { opacity: 1 } : { opacity: 0 }}
            transition={{ delay: 0.5 }}
          >
            ⭐
          </motion.text>
        </motion.g>

        {/* Bid 1 from left */}
        <motion.g
          initial={{ x: -100, opacity: 0 }}
          animate={isInView ? { x: 0, opacity: 1 } : { x: -100, opacity: 0 }}
          transition={{ duration: 0.6, delay: 0.8 }}
        >
          <rect x="40" y="70" width="60" height="35" rx="6" fill="#10b981" stroke="#059669" strokeWidth="2" />
          <text x="70" y="92" textAnchor="middle" fill="white" fontSize="12" fontWeight="bold">£100</text>
          {/* Arrow pointing right */}
          <motion.path
            d="M 105 87 L 135 87"
            stroke="#10b981"
            strokeWidth="3"
            strokeLinecap="round"
            initial={{ pathLength: 0 }}
            animate={isInView ? { pathLength: 1 } : { pathLength: 0 }}
            transition={{ duration: 0.4, delay: 1.2 }}
          />
          <motion.polygon
            points="135,87 125,82 125,92"
            fill="#10b981"
            initial={{ opacity: 0 }}
            animate={isInView ? { opacity: 1 } : { opacity: 0 }}
            transition={{ delay: 1.5 }}
          />
        </motion.g>

        {/* Bid 2 from right */}
        <motion.g
          initial={{ x: 100, opacity: 0 }}
          animate={isInView ? { x: 0, opacity: 1 } : { x: 100, opacity: 0 }}
          transition={{ duration: 0.6, delay: 0.8 }}
        >
          <rect x="300" y="70" width="60" height="35" rx="6" fill="#f59e0b" stroke="#d97706" strokeWidth="2" />
          <text x="330" y="92" textAnchor="middle" fill="white" fontSize="12" fontWeight="bold">£105</text>
          {/* Arrow pointing left */}
          <motion.path
            d="M 295 87 L 265 87"
            stroke="#f59e0b"
            strokeWidth="3"
            strokeLinecap="round"
            initial={{ pathLength: 0 }}
            animate={isInView ? { pathLength: 1 } : { pathLength: 0 }}
            transition={{ duration: 0.4, delay: 1.2 }}
          />
          <motion.polygon
            points="265,87 275,82 275,92"
            fill="#f59e0b"
            initial={{ opacity: 0 }}
            animate={isInView ? { opacity: 1 } : { opacity: 0 }}
            transition={{ delay: 1.5 }}
          />
        </motion.g>

        {/* Collision effect */}
        <motion.g
          initial={{ scale: 0, opacity: 0 }}
          animate={isInView ? { scale: [0, 1.5, 1], opacity: [0, 1, 1] } : { scale: 0, opacity: 0 }}
          transition={{ duration: 0.5, delay: 1.6 }}
        >
          <text x="200" y="185" textAnchor="middle" fontSize="28">💥</text>
        </motion.g>

        {/* Question marks */}
        <motion.text
          x="160"
          y="175"
          fontSize="20"
          initial={{ opacity: 0, y: 10 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 10 }}
          transition={{ delay: 2, duration: 0.3 }}
        >
          ❓
        </motion.text>
        <motion.text
          x="230"
          y="175"
          fontSize="20"
          initial={{ opacity: 0, y: 10 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 10 }}
          transition={{ delay: 2.2, duration: 0.3 }}
        >
          ❓
        </motion.text>

        {/* "Who won?" text */}
        <motion.text
          x="200"
          y="198"
          textAnchor="middle"
          fontSize="14"
          fill="#6b7280"
          fontStyle="italic"
          initial={{ opacity: 0 }}
          animate={isInView ? { opacity: 1 } : { opacity: 0 }}
          transition={{ delay: 2.5 }}
        >
          Who actually won?
        </motion.text>
      </svg>
    </div>
  );
}
